import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import { ADMIN_ALLOWED_HOSTNAMES, createRoutes } from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
    recaptchaVerifier: any;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

function useIsAdminHostname() {
  if (typeof window === "undefined") {
    return false;
  }

  return ADMIN_ALLOWED_HOSTNAMES.includes(window.location.hostname);
}

export function AppRoutes() {
  const isAdminHostname = useIsAdminHostname();
  const element = useRoutes(createRoutes(isAdminHostname));
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return element;
}
